import { loadAndAddImage } from '../image_helpers';
import styles from './pins.module.scss';

const pinColorDict = {
  green: '#428A13',
  gray: '#676767', // community content
  red: '#EB734B', // clusters
  blue: '#219AD8', // pending trails and recordings
  brown: '#907139' // maps
};

const mapPinImageId = color => {
  return `map-pin-${color}`;
};

const mapPinImageSrc = color => {
  return `https://cdn-assets.alltrails.com/assets/icons/maps/pins/map-pin-${color}@2x.png`;
};

const mapPinDiv = (color, opacity) => {
  const div = document.createElement('div');
  div.className = `${styles.pin} ${styles[color]}`;
  if (opacity) {
    div.style.opacity = opacity;
  }
  return div;
};

const pinPopupOffset = [0, -20];

const addPinImageToMap = (map, color) => {
  const imageId = mapPinImageId(color);
  const imageSrc = mapPinImageSrc(color);
  return loadAndAddImage(map, imageId, imageSrc, {
    pixelRatio: 2
  });
};

const addPinImagesToMap = (map, color) => {
  return Promise.all([addPinImageToMap(map, color), addPinImageToMap(map, `${color}-hover`)]);
};

const createPinLayer = (id, sourceId, color, opacity) => {
  return {
    id,
    type: 'symbol',
    source: sourceId,
    filter: ['!', ['has', 'point_count']],
    layout: {
      'icon-allow-overlap': true,
      'icon-anchor': 'bottom',
      'icon-ignore-placement': true,
      'icon-image': ['image', mapPinImageId(color)]
    },
    paint: {
      'icon-opacity': opacity || 1
    }
  };
};

export { pinColorDict, mapPinDiv, mapPinImageId, addPinImageToMap, addPinImagesToMap, createPinLayer, pinPopupOffset };
